<template>
	<div>
		<v-row dense v-if="addressItem">
			<v-col v-if="!$_.get(hiddenFields, 'street', false)" cols="12" sm="6" md="6" lg="6" xl="6">
				<v-text-field
					:disabled="disabled"
					v-model="addressItem.street"
					outlined
					dense
					:label="$t('street')"
				></v-text-field>
			</v-col>
			<v-col v-if="!$_.get(hiddenFields, 'zipCode', false)" cols="12" sm="6" md="6" lg="6" xl="6">
				<v-text-field
					:disabled="disabled"
					v-model="addressItem.zipCode"
					outlined
					dense
					:label="$t('zipCode')"
				></v-text-field>
			</v-col>
			<v-col v-if="!$_.get(hiddenFields, 'city', false)" cols="12" sm="6" md="6" lg="6" xl="6">
				<v-text-field :disabled="disabled" v-model="addressItem.city" outlined dense :label="$t('city')"></v-text-field>
			</v-col>
			<v-col v-if="!$_.get(hiddenFields, 'country', false)" cols="12" sm="6" md="6" lg="6" xl="6">
				<l-autocomplete
					:disabled="disabled"
					v-model="addressItem.country"
					:items="$options.countriesArray"
					item-text="[1]"
					item-value="[0]"
					clearable
					clearvalue=""
					:label="$t('country')"
				></l-autocomplete>
			</v-col>
		</v-row>
	</div>
</template>

<script>
// globals
import countriesArray from '@/plugins/i18nCountries';
// locals
import i18n from './dictionary';
// models
// components
import LAutocomplete from '@/components/base/LAutocomplete.vue';

export default {
	name: `AddressForm`,
	components: { LAutocomplete },
	mixins: [],
	i18n,
	props: {
		value: {
			required: true,
		},
		disabled: {
			type: Boolean,
			required: false,
		},
		hiddenFields: {
			type: Object,
			required: false,
		},
	},
	data() {
		return {};
	},
	computed: {
		addressItem: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
			},
		},
	},
	methods: {},
	created() {
		this.$options.countriesArray = countriesArray;
		// Todo: move to where really needed
		// this.addressItem.country = this.addressItem.country.length >= 1 ? this.addressItem.country : 'AT';
	},
};
</script>
